import useChatMediaCacheStore from '@/stores/useChatMediaCacheStore';

export default function useChatMediaAsset(id: string | null | undefined) {
  return useChatMediaCacheStore((state) =>
    id ? (state.assets[id] ?? null) : null,
  );
}
